import moment from "moment-timezone";

import { IColum } from "../../../../../utils/copyToClipboardInXlsFormat";
import { IntlFormatUSD } from "../../../../../utils";
import { CENTS_IN_DOLLAR, HOURS_12_FORMAT_WITH_DATE } from "../../../../../constants";

export const TABLE_COLUMNS: Array<IColum> = [
  {
    by: "accounts_id",
    title: "Accounts id",
    path: "accounts_id",
  },
  {
    by: "email",
    title: "Email",
    path: "account.email",
  },
  {
    by: "name",
    title: "Name",
    path: "account.name",
  },
  {
    by: "purchase_date",
    title: "Purchase date",
    path: "purchase_date",
    //@ts-ignore
    getCellValue: (row: string): string => {
      return moment(row).tz("America/Chicago").format(HOURS_12_FORMAT_WITH_DATE);
    },
    copyToClipBoardCallBack: (row: string): string => {
      return moment(row).tz("America/Chicago").format(HOURS_12_FORMAT_WITH_DATE);
    },
  },
  {
    by: "price_usd",
    title: "Price",
    path: "price_usd",
    //@ts-ignore
    getCellValue: (row: number): string => {
      return IntlFormatUSD(row / CENTS_IN_DOLLAR);
    },
    //@ts-ignore
    copyToClipBoardCallBack: (row: number): string => {
      return IntlFormatUSD(+row / CENTS_IN_DOLLAR);
    },
  },
  {
    by: "rebill",
    title: "Rebill",
    path: "rebill",
    //@ts-ignore
    getCellValue: (row: boolean): string => {
      return !row ? "FALSE" : "TRUE";
    },
    //@ts-ignore
    copyToClipBoardCallBack: (row: boolean): string => {
      return !row ? "FALSE" : "TRUE";
    },
  },
  {
    by: "reset",
    title: "Reset",
    path: "reset",
    //@ts-ignore
    getCellValue: (row: boolean): string => {
      return !row ? "FALSE" : "TRUE";
    },
    //@ts-ignore
    copyToClipBoardCallBack: (row: boolean): string => {
      return !row ? "FALSE" : "TRUE";
    },
  },
  {
    by: "free_reset",
    title: "Free reset",
    path: "free_reset",
    //@ts-ignore
    getCellValue: (row: boolean): string => {
      return !row ? "FALSE" : "TRUE";
    },
    //@ts-ignore
    copyToClipBoardCallBack: (row: boolean): string => {
      return !row ? "FALSE" : "TRUE";
    },
  },
  {
    by: "transaction_id",
    title: "Transaction Id",
    path: "id",
  },
  {
    by: "plan_name",
    title: "Plan name",
    path: "plan.name",
  },
];
